// extracted by mini-css-extract-plugin
export default {"notice":"HeldDraftNotice_notice__uP3T0","icon":"HeldDraftNotice_icon__-IkTl","text":"HeldDraftNotice_text__Ww55R"};